import { defineComponent as _defineComponent } from 'vue'
import { InputRules } from "@/rules";
import { computed } from "vue";

type Props = {
  value?: string;
  rules?: Function[];
  counter?: number;
};
type Emits = {
  (e: "input", val?: string): void;
  (e: "change", val: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserCodeInput',
  props: {
    value: null,
    rules: { default: () => [] },
    counter: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val?: string): void;
  (e: "change", val: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, rules: Function[], counter?: number };




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const padding = "0";
const counter = 4;
const rules = computed(() => [...props.rules, InputRules.maxLenght(counter)]);

const onChange = (val?: string) => {
  if (val) {
    const padCode = val.padStart(counter, padding);
    modelValue.value = padCode;
    emits("change", padCode);
  }
};

return { __sfc: true,props, emits, modelValue, padding, counter, rules, onChange }
}

})